
import { ref } from 'vue'
import AuthRepository from "@/services/AuthRepository";
import { useToast } from 'primevue/usetoast'
import PasswordModel from '@/models/password.model'
export default {
  setup(){
    const password = ref({} as PasswordModel);
    const toast = useToast();

    const formValid = ()=>{
      const _password = password.value;
      return _password.old_password && _password.password && (_password.password == _password.password2);
    }

    const changePassword = () => {
      AuthRepository.changePassword(password.value)
          .then(()=>{
            toast.add({
              severity:'success',
              summary: 'Cấu hình',
              detail:'Thông tin đã được lưu.',
              life: 1000
            });
          })
          .catch(()=>{
            toast.add({
              severity:'error',
              summary: 'Cấu hình',
              detail:'Lưu cấu hình thất bại.',
              life: 1000
            });
          });
    }

    return{
      password,
      changePassword,
      formValid
    }
  }
}
